import React from 'react';
import { observer } from 'mobx-react';
import Modal from 'react-modal';
import { utcStringToLocalDateTime } from 'common';

@observer
class PaperworkHistoryModal extends React.Component {
    constructor(props) {
        super(props);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    afterOpenModal() {
    }

    closeModal() {
        this.props.onClose();
    }

    render() {
        const {
            isOpen,
        } = this.props;

      const {
          records
        } = this.props.historyData;

        return (
            <Modal
            className="modal--table"
                isOpen={isOpen}
                onAfterOpen={this.afterOpenModal}
            >   
                
                <div className="modal--table__header">
                    <h4 className="type--small type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Entry History</h4>
                    <button className="btn--close" onClick={this.closeModal}>
                        <a href="#" className="modal__close"></a>
                    </button>
                </div>
                <div className="modal--table__content">
                    <table className="table table--fixed spc--bottom--sml">
                        <thead className="table__head">
                            <tr className="table__head__row">
                                <th className="table__head__data">
                                    Edited By
                                </th>
                                <th className="table__head__data">
                                    Old Status
                                </th>
                                <th className="table__head__data">
                                    New Status
                                </th>
                                <th className="table__head__data">
                                    Date
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                records.map(item => {
                                    return <EntryHistoryListItem key={item.id} item={item}/>
                                })
                            }
                        </tbody>
                    </table>
                </div>

            </Modal>
        )
    }
}


const EntryHistoryListItem = ({ item }) => {
    return (
        <tr className="table__body__row">
            <td className="table__body__data">
                <span>{item.user.username}</span>
            </td>
            <td className="table__body__data">
                <span>{item.oldStatus.description}</span>
            </td>    
            <td className="table__body__data">
                <span>{item.newStatus.description}</span>
            </td>                    
            <td className="table__body__data">
            <span>{utcStringToLocalDateTime(item.createdOn)}</span>
            </td>   
        </tr>
    );
}

export { PaperworkHistoryModal }



// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/components/PaperworkHistoryModal.js